enum RepairOrderStatusType {
    Estimate,
    Invoice,
}

export default RepairOrderStatusType;
